import { FormControl, Grid } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import DefaultButton from '../../../components/FormControl/DefaultButton';
import ErrorButton from '../../../components/FormControl/ErrorButton';
import FormDialog from '../../../components/FormControl/FormDialog';
import OrangeButton from '../../../components/FormControl/OrangeButton';
import { MultiSelectOption } from '../../../components/MultiSelect';
import SearchEntity from '../../../components/SelectSearch/SearchEntity';
import UserType from '../../../enum/UserType';
import FinalCustomer from '../../../model/FinalCustomer';
import Integrator from '../../../model/Integrator';
import TicketStatus from '../../../model/TicketStatus';
import User from '../../../model/User';
import { WhereCondition } from '../../../service/ServiceApi';
import { ServiceApi } from '../../../service/ServiceApiWithLoading';
import { useAuthentication } from '../../../reducer/authentication';

const apiTicketStatus = new ServiceApi<TicketStatus>('ticketStatus');

export interface TicketsFiltersFormDialogData {
    final_customer_id: number | null;
    user_id: number | null;
    description: string;
}

export interface TicketsFiltersFormDialogProps {
    filterDialogOpen: boolean;
    onSubmit: (data: TicketsFiltersFormDialogData) => any;
    onCancel: () => any;
    filters: TicketsFiltersFormDialogData;
    disableUserFilter: boolean;
    disableFinalCustomerFilter: boolean;
}

export default function TicketsFiltersFormDialog(props: TicketsFiltersFormDialogProps) {
    const { onSubmit, filterDialogOpen, onCancel, filters, disableUserFilter, disableFinalCustomerFilter } = props;
    const { description, final_customer_id, user_id } = filters;
    const { enqueueSnackbar } = useSnackbar();
    const { user } = useAuthentication();

    useEffect(() => {

    }, []);

    function onSubmitHandler(data: TicketsFiltersFormDialogData) {
        onSubmit(data);
    }

    function clearFilters() {
        onSubmit({
            final_customer_id: null,
            user_id: null,
            description: ''
        });
    }

    //tem que ver isso, pra trazer só usuários cliente quando cliente, cliente e integrador quando integrador
    const extraWhereUser: WhereCondition<User> = [['active', '=', true]];
    const extraOrWhereUser: WhereCondition<User> = [];
    if(user?.type === UserType.FinalCustomer){
        extraOrWhereUser.push(['final_customer_id', '=', user?.final_customer_id]);
        extraOrWhereUser.push(['integrator_id', '=', user?.final_customer?.integrator_id]);
    } else {
        extraOrWhereUser.push(['integrator_id', '=', user?.integrator_id]);
        extraOrWhereUser.push(['final_customer.integrator_id', '=', user?.integrator_id]);
    }
    return (
        <FormDialog<TicketsFiltersFormDialogData>
            show={filterDialogOpen}
            title={'Filtros'}
            dismiss={() => null}
            onSubmit={(values, dirty, errors) => {
                if (errors) {
                    var errorValues = Object.values(errors);
                    for (var key in errorValues) {
                        var error = errorValues[key];
                        if (error) {
                            enqueueSnackbar(error, { variant: 'error' });
                        }
                    }
                    return;
                }
                onSubmitHandler(values);
            }}
            initialValues={{
                final_customer_id,
                user_id,
                description
            }}
            enableReinitialize={true}
            maxWidth='sm'
            fullWidth
        >
            {({ values, errors, handleChange, handleChangeNumber, setFieldValue, isSubmitting, dirty }) => (
                <>
                    <FormControl fullWidth variant="outlined" margin='dense'>
                        <Grid container spacing={2}>
                            {!disableFinalCustomerFilter ? <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                                <SearchEntity<FinalCustomer, 'id', 'name'>
                                    name="final_customer_id"
                                    entity="finalCustomer"
                                    valueField='id'
                                    labelField="name"
                                    label="Cliente final"
                                    value={values.final_customer_id}
                                    onChangeHandle={(_, v) => setFieldValue('final_customer_id', v)}
                                    isClearable
                                />
                            </Grid> : null}
                            {!disableUserFilter ? <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                                <SearchEntity<User, 'id', 'name'>
                                    name="user_id"
                                    entity="user"
                                    valueField='id'
                                    labelField="name"
                                    label="Aberto por"
                                    value={values.user_id}
                                    onChangeHandle={(_, v) => setFieldValue('user_id', v)}
                                    extraWhere={extraWhereUser}
                                    extraOrWhere={extraOrWhereUser}
                                    isClearable
                                    normalizeSearch
                                />
                            </Grid> : null}
                        </Grid>
                    </FormControl>
                    <FormControl fullWidth variant="outlined" margin="dense" style={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
                        <ErrorButton
                            size='small'
                            variant="contained"
                            disabled={isSubmitting}
                            onClick={() => onCancel()}                            >
                            Cancelar
                        </ErrorButton>
                        <OrangeButton
                            size='small'
                            variant="contained"
                            disabled={isSubmitting}
                            onClick={() => clearFilters()}
                            style={{ marginLeft: 10 }}>
                            Limpar
                        </OrangeButton>
                        <DefaultButton
                            size='small'
                            type='submit'
                            variant="contained"
                            style={{ marginLeft: 10 }}
                            disabled={isSubmitting}>
                            Filtrar
                        </DefaultButton>
                    </FormControl>
                </>
            )}
        </FormDialog>
    );
}